// The columns each list exports (#9): what's on screen, plus the few
// fields someone working in a spreadsheet would want next (due date, VAT, net).
import type { Contact, DocumentSummary } from '../../data/source';
import type { ExportColumn } from './exportList';

const STATUS: Record<string, string> = { draft: 'Draft', posted: 'Unpaid', part_paid: 'Part paid', paid: 'Paid', void: 'Void' };
const status = (d: DocumentSummary) => STATUS[d.status] ?? d.status;

export const salesColumns: ExportColumn<DocumentSummary>[] = [
  { header: 'Number', value: (d) => d.doc_no ?? 'Draft' },
  { header: 'Customer', value: (d) => d.contact_name },
  { header: 'Issued', kind: 'date', value: (d) => d.issue_date },
  { header: 'Due', kind: 'date', value: (d) => d.due_date },
  { header: 'Status', value: status },
  { header: 'Currency', value: (d) => d.currency },
  { header: 'Net', kind: 'money', value: (d) => d.net_total },
  { header: 'VAT', kind: 'money', value: (d) => d.tax_total },
  { header: 'Total', kind: 'money', value: (d) => d.gross_total },
  { header: 'Outstanding', kind: 'money', value: (d) => (d.status === 'draft' || d.status === 'void' ? null : d.outstanding) },
];

export const billColumns: ExportColumn<DocumentSummary>[] = [
  { header: 'Supplier', value: (d) => d.contact_name },
  { header: 'Their number', value: (d) => d.supplier_ref },
  { header: 'Our number', value: (d) => d.doc_no },
  { header: 'Type', value: (d) => (d.type === 'purchase_credit' ? 'Credit note' : 'Bill') },
  { header: 'Dated', kind: 'date', value: (d) => d.issue_date },
  { header: 'Due', kind: 'date', value: (d) => d.due_date },
  { header: 'Status', value: status },
  { header: 'Currency', value: (d) => d.currency },
  { header: 'Net', kind: 'money', value: (d) => d.net_total },
  { header: 'VAT', kind: 'money', value: (d) => d.tax_total },
  { header: 'Total', kind: 'money', value: (d) => d.gross_total },
  { header: 'To pay', key: 'outstanding', kind: 'money', value: (d) => (d.status === 'draft' || d.status === 'void' ? null : d.outstanding) },
  { header: 'Total in euro', key: 'base_total', kind: 'money', value: (d) => d.base_gross_total },
];

export const contactColumns = (role: 'customer' | 'supplier'): ExportColumn<Contact>[] => [
  { header: 'Code', value: (c) => c.code },
  { header: 'Name', value: (c) => c.name },
  { header: 'Email', value: (c) => c.email },
  { header: 'VAT number', value: (c) => c.vat_number },
  { header: 'Country', value: (c) => c.country },
  { header: 'Currency', value: (c) => c.currency ?? 'EUR' },
  { header: 'Terms (days)', key: 'payment_terms_days', kind: 'number', value: (c) => c.payment_terms_days ?? 30 },
  { header: 'Terms from', key: 'payment_terms_basis', value: (c) => (c.payment_terms_basis === 'end_of_month' ? 'End of month' : 'Invoice date') },
  { header: role === 'customer' ? 'Owes you' : 'You owe', key: 'balance', kind: 'money', value: (c) => c.balance },
  { header: 'Overdue', kind: 'money', value: (c) => c.overdue },
];
